module.exports = __webpack_public_path__ + "img/korzinka_logo_new.a75d4e58.png";